module.exports = __webpack_public_path__ + "static/bg00-7a1401ca1616509c21b2346d73717909.jpg";